import navigation from './navigation.module.scss';

export interface INavigationHeights {
  navHeight: string;
  mainNavHeight: string;
  mainNavZIndex: string;
  shopNavigationHeight: string;
  stickyHeaderHeight: string;
}
const navigationHeights = navigation as unknown as INavigationHeights;

export {
  navigationHeights,
};
